import {Injectable} from '@angular/core';
import {NavigationItem} from "../interfaces/navigation-item.interface";

const ITEMS: NavigationItem[] = [
  {
    type: 'link',
    label: 'Users',
    icon: 'mat:group',
    textClass: 'text-white',
    route: '/users/list',
    badge: {
      value: '',
      bgClass: '',
      icon: '',
      textClass: 'text-deep-purple-contrast',
    }
  },
  {
    type: 'link',
    label: 'Passed users',
    icon: 'mat:group',
    textClass: 'text-white',
    route: '/passed-users-list',
    badge: {
      value: '',
      bgClass: '',
      icon: '',
      textClass: 'text-deep-purple-contrast',
    }
  },
  {
    type: 'link',
    label: 'Doors',
    icon: 'mat:sensor_door',
    textClass: 'text-white',
    route: '/doors/list',
    badge: {
      value: '',
      bgClass: '',
      icon: '',
      textClass: 'text-deep-purple-contrast',
    }
  },
  {
    type: 'link',
    label: 'Challenges',
    icon: 'mat:quiz',
    textClass: 'text-white',
    route: '/challenges/list',
    badge: {
      value: '',
      bgClass: '',
      icon: '',
      textClass: 'text-deep-purple-contrast',
    }
  },
  {
    type: 'link',
    label: 'Questions banks',
    icon: 'mat:help',
    textClass: 'text-white',
    route: '/questions-banks/list',
    badge: {
      value: '',
      bgClass: '',
      icon: '',
      textClass: 'text-deep-purple-contrast',
    }
  },
  // {
  //   type: 'link',
  //   label: 'Performance management',
  //   icon: 'mat:group',
  //   textClass: 'text-white',
  //   route: '/performance-management/list',
  //   badge: {
  //     value: '',
  //     bgClass: '',
  //     icon: '',
  //     textClass: 'text-deep-purple-contrast',
  //   }
  // },
  {
    type: 'dropdown',
    label: 'Notifications',
    icon: 'mat:notifications',
    children: [
      {
        type: 'link',
        label: 'Send to users',
        icon: 'mat:add_alert',
        route: '/notifications/select-users-list',
        badge: {
          value: '',
          bgClass: '',
          icon: 'mat:add',
          textClass: 'text-deep-purple-contrast',
        }
      },
      {
        type: 'link',
        label: 'Users notifications',
        icon: 'mat:notifications_active',
        route: '/notifications/users-list',
        badge: {
          value: '',
          bgClass: '',
          icon: 'mat:add',
          textClass: 'text-deep-purple-contrast',
        }
      },
    ]
  },
  {
    type: 'dropdown',
    label: 'Settings',
    icon: 'mat:settings',
    children: [
      {
        type: 'link',
        label: 'Reference numbers',
        icon: 'mat:psychology',
        textClass: 'text-white',
        route: '/settings/reference-numbers/list',
        badge: {
          value: '',
          bgClass: '',
          icon: '',
          textClass: 'text-deep-purple-contrast',
        }
      },
      {
        type: 'link',
        label: 'Banks',
        icon: 'mat:banks',
        textClass: 'text-white',
        route: '/settings/banks/list',
        badge: {
          value: '',
          bgClass: '',
          icon: '',
          textClass: 'text-deep-purple-contrast',
        }
      },
      {
        type: 'link',
        label: 'System settings',
        icon: 'mat:settings',
        textClass: 'text-white',
        route: '/settings/system',
        badge: {
          value: '',
          bgClass: '',
          icon: '',
          textClass: 'text-deep-purple-contrast',
        }
      },
    ]
  },
];

@Injectable()
export class SideNavItems {
  getAll(): NavigationItem[] {
    return ITEMS;
  }
}
